
 export const NFT_addr = "0xD77FF05c2cdc7a85346320bb9D1e2b67A8aBD1Be"
 export const USDG_addr = "0xD616Cfc2F83d084471eB241Ea1Be7b1E7Da64eCe"
 export const config_addr = "0x6d8C0EE06c3ff50a82224bb701bA438Aa9015Ef9"
 export const market_addr = "0xEF753e458cB6f48E6f7CAA54a72C10DE3F789C38"
 export const uSDT_addr = "0x1398DE2BD9DD343f1e1DA15a79766448553E64e5"
 export const StableVault_addr = "0x24893b7D312F551aaF119B7e5e5DCA26A07AA595"
